import classes from "./NotFound.module.scss";
import ContentWrapper from '../../components/shared/ContentWrapper';
import HelmetWrapper from '../../components/shared/HelmetWrapper';
import HelmetContent from "../../routes/helmet";

export default function NotFound() {
    const notFoundTextList = [
        "Is the website address correct?",
        "404 Not Found!",
        "Check for a typo",
        "Try contacting the owner",
        "This might be an outdated link",
        "The page you are looking for doesn't exist",
        "Well this is awkward",
        "It's not here! Look somewhere else",
    ]
    const notFoundText = notFoundTextList[Math.floor(Math.random() * notFoundTextList.length)];

    return (
        <ContentWrapper>
            <HelmetWrapper content={HelmetContent.other.NotFound} />

            <div className={classes.Wrapper}>
                <h1>Oopsy!</h1>
                <h1>Page not found!</h1>
                <h2>{notFoundText}</h2>
            </div>
        </ContentWrapper>
    )
}